import React from 'react'
import { Caption } from './Caption'
import styled from 'styled-components'

const ImagesWrapper = styled.div`
  display: flex;
  flex-direction: ${props => (props.vertical ? 'column' : 'row')};
  width: 100%;
  align-items: center;
  justify-content: space-evenly;
`

const ImageWrapper = styled.div`
  margin: 0 5px;
  max-width: ${props => (props.vertical ? '100%' : '50%')};
`

const AdjustableImage = styled.img`
  margin-bottom: 10px;
  -webkit-box-shadow: 0px 15px 30px 0px rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 0px 15px 30px 0px rgba(0, 0, 0, 0.25);
  box-shadow: 0px 15px 30px 0px rgba(0, 0, 0, 0.25);
`

export const TwoImages = ({
  src1,
  src2,
  alt1,
  alt2,
  caption,
  nr,
  prefix = 'Rys.',
  vertical = false,
}) => {
  const captionText = caption ?? `${alt1} & ${alt2}`
  return (
    <figure>
      <ImagesWrapper vertical={vertical}>
        <ImageWrapper vertical={vertical}>
          <AdjustableImage src={src1} alt={alt1 ?? caption} />
        </ImageWrapper>
        <ImageWrapper vertical={vertical}>
          <AdjustableImage src={src2} alt={alt2 ?? alt1 ?? caption} />
        </ImageWrapper>
      </ImagesWrapper>
      <Caption nr={nr} prefix={prefix} text={captionText} />
    </figure>
  )
}
